import { render, staticRenderFns } from "./UM_blockedUser.vue?vue&type=template&id=6e5b401a&scoped=true&"
import script from "./UM_blockedUser.vue?vue&type=script&lang=js&"
export * from "./UM_blockedUser.vue?vue&type=script&lang=js&"
import style0 from "./UM_blockedUser.vue?vue&type=style&index=0&id=6e5b401a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5b401a",
  null
  
)

export default component.exports